/* =============================================================================
   CORREO DEL HOTEL, OFUSCADO
   Los robots que juntan direcciones para mandar spam leen el HTML y los
   archivos .js tal como llegan del servidor y buscan "algo@dominio" o
   "mailto:". Por eso la dirección no aparece escrita en ningún archivo del
   sitio: se arma aquí, en el navegador, y se pinta al cargar.

   Uso en el HTML:
     <a data-correo>…</a>             → recibe href="mailto:<correo>"
     <span data-correo-texto></span>  → recibe el correo como texto
   En los textos de i18n.js, {correo} se reemplaza por la dirección.

   Tiene que cargar ANTES que i18n.js y app.js (los dos la leen de
   window.LG_CORREO). Para cambiar el correo, cambiar solo estas dos partes.
   ============================================================================= */
(function () {
  var usuario = 'lagruta';
  var dominio = 'lagrutahotel.com';
  var correo = usuario + String.fromCharCode(64) + dominio;
  window.LG_CORREO = correo;

  function pintar() {
    document.querySelectorAll('[data-correo]').forEach(function (a) {
      a.setAttribute('href', 'mailto:' + correo);
    });
    document.querySelectorAll('[data-correo-texto]').forEach(function (el) {
      el.textContent = correo;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pintar);
  else pintar();
})();
